document.addEventListener('DOMContentLoaded', function () {
    function updateProductImage(card, variantData, variantId) {
        var productImageElement = card.querySelector('.card__media img');
        if (productImageElement) {
            var lazyLoadAllVariants = card.getAttribute('data-lazy-load-all-variants') === 'true';
            if (lazyLoadAllVariants) {
                var preloadedImage = card.querySelector(`img[data-variant-id="${variantId}"]`);
                if (preloadedImage) {
                    productImageElement.src = preloadedImage.src;
                    productImageElement.srcset = preloadedImage.srcset;
                }
            } else if (variantData && variantData.imageUrl) {
                var dynamicSrcset = [
                    `${variantData.imageUrl}?width=165 165w`,
                    `${variantData.imageUrl}?width=360 360w`,
                    `${variantData.imageUrl}?width=533 533w`,
                    `${variantData.imageUrl}?width=720 720w`,
                    `${variantData.imageUrl}?width=940 940w`,
                    `${variantData.imageUrl}?width=1066 1066w`
                ].join(', ');
                productImageElement.srcset = dynamicSrcset;
                productImageElement.src = variantData.imageUrl;
            }
        }
    }

    function updateProductPrice(card, variantPrice) {
        const priceContainer = card.querySelector('.price__container');
        if (priceContainer && variantPrice) {
            const regularPriceElement = priceContainer.querySelector('.price-item--regular');
            const salePriceElement = priceContainer.querySelector('.price-item--sale');

            const formatPriceWithUSD = (price) => {
                price = price.replace(/\s*USD\s*$/, '').trim();
                return `${price}`;
            };

            if (regularPriceElement) {
                regularPriceElement.textContent = formatPriceWithUSD(variantPrice);
            }

            if (salePriceElement) {
                salePriceElement.textContent = formatPriceWithUSD(variantPrice);
            }
        }
    }

    function updateProductLinks(card, variantData) {
        var productLinks = card.querySelectorAll('a[id^="CardLink-"], a[id^="StandardCardNoMediaLink-"]');
        productLinks.forEach(function (link) {
            link.href = variantData.productUrl;
        });

        var quickAddButton = card.querySelector('.quick-add__submit');
        if (quickAddButton) {
            quickAddButton.setAttribute('data-product-url', variantData.productUrl);
        }
    }

    function storeSelectedVariant(sectionId, productId, variantId, variantPrice) {
        sessionStorage.setItem('selectedVariant-' + sectionId + '-' + productId, variantId);
        sessionStorage.setItem('selectedVariantPrice-' + sectionId + '-' + productId, variantPrice);
    }

    function storeSelectedSwatch(sectionId, productId, variantId) {
        sessionStorage.setItem('selectedSwatch-' + sectionId + '-' + productId, variantId);
    }

    function restoreSelectedVariant(productGrid, sectionId, productId, variantDataMap) {
        var selectedVariantId = sessionStorage.getItem('selectedVariant-' + sectionId + '-' + productId);
        var selectedVariantPrice = sessionStorage.getItem('selectedVariantPrice-' + sectionId + '-' + productId);
        if (selectedVariantId && variantDataMap[selectedVariantId]) {
            var card = productGrid.querySelector(`.card-product-custom-div[data-section-id="${sectionId}"][data-product-id="${productId}"]`);
            var variantData = variantDataMap[selectedVariantId];
            updateProductImage(card, variantData, selectedVariantId);
            updateProductLinks(card, variantData);
            if (selectedVariantPrice) {
                updateProductPrice(card, selectedVariantPrice);
            }
        }
    }

    function restoreSelectedSwatch(productGrid, sectionId, productId) {
        var selectedVariantId = sessionStorage.getItem('selectedSwatch-' + sectionId + '-' + productId);
        if (selectedVariantId) {
            var swatchInput = productGrid.querySelector(`input[type="radio"][data-variant-id="${selectedVariantId}"][data-section-id="${sectionId}"]`);
            if (swatchInput) {
                swatchInput.checked = true;
            }
        }
    }

    function initializeProductGrid(productGrid) {
        var sectionId = productGrid.getAttribute('data-id');
        productGrid.querySelectorAll('.card-product-custom-div:not(.loaded)').forEach(function (card) {
            var productId = card.getAttribute('data-product-id');
            var variantDataMap = window['variantDataMap' + sectionId.replace(/-/g, '_') + '_' + productId];

            restoreSelectedVariant(productGrid, sectionId, productId, variantDataMap);
            restoreSelectedSwatch(productGrid, sectionId, productId);

            card.addEventListener('change', function (e) {
                if (e.target.matches(`input[type="radio"][data-section-id="${sectionId}"]`)) {
                    var variantId = e.target.getAttribute('data-variant-id');
                    var variantPrice = e.target.getAttribute('data-variant-price');
                    var variantData = variantDataMap[variantId];
                    if (!variantData) {
                        return;
                    }
                    storeSelectedVariant(sectionId, productId, variantId, variantPrice);
                    storeSelectedSwatch(sectionId, productId, variantId);
                    updateProductImage(card, variantData, variantId);
                    updateProductLinks(card, variantData);
                    updateProductPrice(card, variantPrice);
                }
            });

            card.classList.add('loaded');
        });
    }

    function initializeAllProductGrids() {
        var productGrids = document.querySelectorAll('.grid.product-grid');
        productGrids.forEach(initializeProductGrid);
    }

    // Initial load
    initializeAllProductGrids();

    // Observer setup with disconnect protection
    var config = { childList: true, subtree: true };
    var observer = new MutationObserver(function (mutations) {
        observer.disconnect(); // stop observing while we make changes
        let needsInit = false;

        mutations.forEach(function (mutation) {
            if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                needsInit = true;
            }
        });

        if (needsInit) {
            initializeAllProductGrids();
        }

        observer.observe(document.body, config); // resume observing
    });

    observer.observe(document.body, config);
});
